<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.studentAidaId" class="accountRect" @click="selectAccount=item">
      <van-row>
        <van-col span="12">{{ item.emailAddress }}</van-col>
        <van-col span="12" class="rigth">
          <van-tag v-if="item.initPassword && !item.isSetPassword" type="primary" :color="GetColorMainBack()">初始密码</van-tag>
          <van-tag v-if="item.isSetPassword" type="primary" :color="GetColorMainBack()">已设置密码</van-tag>
          {{ item.initPassword }}
        </van-col>
      </van-row>
    </div>
    <div class="downEmpty" />
    <div class="downAbout">
      1.设置您已经注册的AIDA账号密码，可以便捷确认AIDA课程；<br>
      2.您可以通过<b>初始密码</b>登陆AIDA官网；<br>
      3.AIDA官网登陆地址:https://eos.aidainternational.org/profile
    </div>
    <aidaAccountSet v-model="selectAccount" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import aidaAccountSet from '@/views/my/aidaAccountSet'
export default {
  components: {
    [Button.name]: Button,
    [Tag.name]: Tag,
    TopBar,
    aidaAccountSet
  },
  data() {
    return {
      titleTop: '',
      title: 'AIDA账号管理',
      backurl: '/my/index',
      list: [],
      selectAccount: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/user/getUserAidaAccount',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
        if (callback) {
          callback()
        }
      })
    }
  }
}
</script>
<style scoped>
.accountRect{
    background-color: #fff;
    border-radius: 0.4em;
    padding: 1em 0.5em;
    margin: 1em;
}
.downAbout{
    background-color:#F1F1F1 ;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 0.8em;
    color: #999;
    padding: 0.5em 1em;
    border-top: 1px solid #f5f5f5;
}
.downEmpty{
    height: 5em;
}
</style>
